export const dorotaKuffel = {
    'meta': {
        'title': 'Psychoterapeuta dorosłych oraz młodzieży Dorota Kuffel',
        'description': 'Prowadzę indywidualną terapię osób dorosłych, młodzieży od lat 15 oraz terapię par. Swoją praktykę poddaję regularnej superwizji.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-psychoterapeuta-dorota-kuffel/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/dorota-kuffel.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy, Psychoterapeuta w Bydgoszczy Dorota Kuffel'
        }
    }
}